/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Col_VarianceInputs */

const vi_stocktake_col_variance = /** @type {(inputs: Stocktake_Col_VarianceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sai lệch`)
};

/**

* @param {Stocktake_Col_VarianceInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_col_variance = /** @type {((inputs?: Stocktake_Col_VarianceInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Col_VarianceInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_col_variance(inputs)
});